import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Pagination, Spinner } from '@/components/ui'
import { useBienContext } from "@/features/biens/BienContext"

import { fetchBienDocuments } from '@/features/documents/documentsSlice'
import DocumentItem from './DocumentItem'

const TYPE_DOCUMENT = "document_legal"
 
export default () => {
  const dispatch = useDispatch()
  const { bien } = useBienContext()
  const loading = useSelector( state => state.documents.loadingStatus.fetchList )
  const documents = useSelector( state => 
    state.documents[TYPE_DOCUMENT].items
  )
  const pagination = useSelector( state => 
    state.documents[TYPE_DOCUMENT].pagination
  )

  const [ filters, setFilters ] = useState({
    bienId: bien.id,
    page: pagination.currentPage
  })
  const [isLoading, setIsLoading] = useState(false)

  // useEffect qui gère le chargement initial 
  // Chargement initial quand bien.id est disponible et documents est vide
  useEffect(
    () => {
      if (documents.length == 0 && bien?.id) {
        setIsLoading(true)
        dispatch(fetchBienDocuments({...filters}))
      }
    },
    [bien?.id, documents.length]
  )

  // useEffect qui gère le changement de page
  useEffect(
    () => {
      // On ignore le premier rendu en vérifiant si la page est différente de celle par défaut
      if (filters.page !== pagination.currentPage) {
        setIsLoading(true)
        dispatch(fetchBienDocuments({...filters}))
      }
    },
    [filters.page]
  )

  useEffect(
    () => {
      if(!loading && isLoading) {
        setIsLoading(false)
      }
    },
    [loading]
  )
  
  const handlePageChange = (page) => {
    // Mettre à jour les filtres avec la nouvelle page
    setFilters({ ...filters, page })
  }

  return (
    <div className='overflow-hidden mb-4'>
      <h3 className="text-md font-semibold mb-2">
        Vos documents légaux 
      </h3>
      <div className="bg-primary-100 p-4 rounded-none h-full"> 
        { isLoading && <Spinner /> }
        { !isLoading && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"> 
            { documents.length == 0 ? 
              <p className="col-span-2 text-center">Aucun document</p> :
              <>
                <div className="flex flex-col gap-4 items-center">
                  {documents.slice(0, Math.ceil(documents.length/3)).map(item => 
                    <DocumentItem key={item.id} item={item} />
                  )}
                </div>
                <div className="flex flex-col gap-4 items-center">
                  {documents.slice(Math.ceil(documents.length/3), Math.ceil(documents.length/3)*2).map(item => 
                    <DocumentItem key={item.id} item={item} />
                  )}
                </div>
                <div className="flex flex-col gap-4 items-center">
                  {documents.slice(Math.ceil(documents.length/3)*2).map(item => 
                    <DocumentItem key={item.id} item={item} />
                  )}
                </div>
              </>
            }
        </div> }
        { pagination && pagination.totalPages > 1 && 
          <Pagination 
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
          />
        }
      </div>
    </div>
  )
}